<template>
  <div class="container">
    <Header></Header>
    <headerSearch></headerSearch>
    <mainTab :nindex="2"></mainTab>
    <div class="activities_wrap">
      <div class="w1440">
        <swiper
          :pagination="{ clickable: true }"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          @swiper="onSwiper"
          class="home_swiper"
          :observer="true"
          :observeParents="true"
          :modules="modules"
          loop
          ref="swiper"
        >
          <swiper-slide class="swiper_item" v-for="(item, index) in banner" :key="index">
            <a @click="jump(item.url)" class="top_banner cu flex flex-center flex-col" :style="{ backgroundImage: `url(${item.image_text})` }"> </a>
          </swiper-slide>
        </swiper>

        <!-- Tab -->
        <!-- <div class="flex-box flex-between menu_row">
          <div
            class="menu_tab"
            v-for="(item, index) in tablist"
            :key="index"
            @click="onActivityClick(index)"
          >
          <img :src="require('@/assets/static/icon/z_icon_menu_pic' + (index + 1) + '.png')" />
          </div>
        </div> -->

        <div class="flex-box flex-between menu_row">
          <div class="menu_tab" @click="onActivityClick(0)">
            <img src="@/assets/static/icon/z_icon_menu_pic1.png" />
          </div>
          <div class="menu_tab" @click="onActivityClick(2)">
            <img src="@/assets/static/icon/z_icon_menu_pic3.png" />
          </div>
          <div class="menu_tab" @click="onActivityClick(1)">
            <img src="@/assets/static/icon/z_icon_menu_pic2.png" />
          </div>
          <div class="menu_tab" @click="onActivityClick(3)">
            <img src="@/assets/static/icon/z_icon_menu_pic4.png" />
          </div>
        </div>

        <!-- 限时购 标题 -->
        <div
          v-if="tablist[tabIndex].type == 'seckill'"
          class="today_tab flex-box active1"
          :class="{ active1: spikesIndex == 0, active2: spikesIndex == 1 }"
        >
          <div class="flex-grow-1 tab_item tab_item1" :class="{ active: spikesIndex == 0 }" @click="checkSpikes(0)"></div>
          <div class="flex-grow-1 tab_item tab_item2" :class="{ active: spikesIndex == 1 }" @click="checkSpikes(1)"></div>
        </div>

        <div
          class="product_box2"
          :class="{
            groupon_box: tablist[tabIndex].type == 'groupon',
            new_sample_box: tablist[tabIndex].type == 'new_sample',
            seckill_box: tablist[tabIndex].type == 'seckill',
            expiry_food_box: tablist[tabIndex].type == 'expiry_food',
          }"
        >
          <!-- 万件拼团 标题 -->
          <div
            v-if="tablist[tabIndex].type == 'groupon'"
            class="title_box"
            :class="{ groupon: tablist[tabIndex].type == 'groupon' }"
          >
            <img src="@/assets/static/icon/z_icon_title1.png" class="icon_title1" />
          </div>
          <!-- 新品体验 标题 -->
          <div
            v-if="tablist[tabIndex].type == 'new_sample'"
            class="title_box"
            :class="{ new_sample: tablist[tabIndex].type == 'new_sample' }"
          >
            <img src="@/assets/static/icon/z_icon_title2.png" class="icon_title1" />
          </div>
          <!-- 临期产品 标题 -->
          <div
            v-if="tablist[tabIndex].type == 'expiry_food'"
            class="title_box"
            :class="{ expiry_food: tablist[tabIndex].type == 'expiry_food' }"
          >
            <img src="@/assets/static/icon/z_icon_title3.png" class="icon_title1" />
          </div>

          <div class="product_box2_inner">
            <!-- 倒计时 -->
            <template v-if="tablist[tabIndex].type == 'seckill'">
              <!-- 倒计时 今日秒杀  -->
              <div class="countdown_box" v-if="spikesIndex == 0 && tablist[tabIndex].today_activity">
                <div class="flex-box">
                  <div class="btn_count"><span>限时秒杀时间</span></div>
                  <div class="flex-grow-1 flex-box flex-center">
                    <div class="count_item" :style="{ backgroundImage: `url(${coutimg})` }">{{ todaysh }}</div>
                    <div class="count_span"></div>
                    <div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg})` }">{{ todaysm }}</div>
                    <div class="count_span_split"></div>
                    <div class="count_item" :style="{ backgroundImage: `url(${coutimg})` }">{{ todayeh }}</div>
                    <div class="count_span"></div>
                    <div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg})` }">{{ todayem }}</div>
                  </div>
                  <div class="btn_count"><span>限时秒杀时间</span></div>
                </div>
                <div class="tc">
                  <countDown2 ref="countDown" :time="tablist[tabIndex].today_activity?.seconds * 1000" @change="onChange">
                    <div class="img_tip3 flex-box flex-center flex-col-baseline fs18">
                      <div class="ztime1">距离秒杀结束还剩：</div>
                      <div class="time" v-if="timeData.days">{{ timeData.days }}</div>
                      <div class="text1" v-if="timeData.days">天</div>
                      <div class="time">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</div>
                      <div class="text1">时</div>
                      <div class="time">{{ timeData.minutes }}</div>
                      <div class="text1">分</div>
                      <div class="time">{{ timeData.seconds }}</div>
                      <div class="text1">秒</div>
                    </div>
                  </countDown2>
                </div>
              </div>
              <!-- 倒计时 明日预告 -->
              <div class="countdown_box" v-if="spikesIndex == 1 && tablist[tabIndex].tomorrow_activity">
                <div class="flex-box">
                  <div class="btn_count_uc"><span>限时秒杀时间</span></div>
                  <div class="flex-grow-1 flex-box flex-center">
                    <div class="count_item" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{ tomorrowsh }}</div>
                    <div class="count_span gray"></div>
                    <div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{ tomorrowsm }}</div>
                    <div class="count_span_split gray"></div>
                    <div class="count_item" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{ tomorroweh }}</div>
                    <div class="count_span gray"></div>
                    <div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{ tomorrowem }}</div>
                  </div>
                  <div class="btn_count_uc"><span>限时秒杀时间</span></div>
                </div>
                <div class="tc">
                  <countDown2 ref="countDown" :time="tablist[tabIndex].tomorrow_activity?.seconds * 1000" @change="onChange">
                    <div class="img_tip3 flex-box flex-center flex-col-baseline fs18">
                      <div class="ztime1">距离秒杀开始还剩：</div>
                      <div class="time" v-if="timeData.days">{{ timeData.days }}</div>
                      <div class="text1" v-if="timeData.days">天</div>
                      <div class="time">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</div>
                      <div class="text1">时</div>
                      <div class="time">{{ timeData.minutes }}</div>
                      <div class="text1">分</div>
                      <div class="time">{{ timeData.seconds }}</div>
                      <div class="text1">秒</div>
                    </div>
                  </countDown2>
                </div>
              </div>
            </template>
            <!-- 筛选 -->
            <div class="select_wrap1 fs16">
              <div class="rank_row flex-box">
                <div class="flex-box rank" :class="query.sort == 'sales' ? 'active' : ''" @click="onSort('sales')">
                  <div>产品销量</div>
                  <img
                    v-if="query.sort == 'sales' && query.order == 'asc'"
                    src="@/assets/static/icon/z_icon_rank2.png"
                    class="icon_rank"
                  />
                  <img
                    v-else-if="query.sort == 'sales' && query.order == 'desc'"
                    src="@/assets/static/icon/z_icon_rank3.png"
                    class="icon_rank"
                  />
                  <img v-else src="@/assets/static/icon/z_icon_rank1.png" class="icon_rank" />
                </div>
                <div class="flex-box rank" :class="query.sort == 'price' ? 'active' : ''" @click="onSort('price')">
                  <div>价格区间</div>
                </div>
                <div class="flex-box rank" :class="query.sort == 'stock' ? 'active' : ''" @click="onSort('stock')">
                  <div>库存数量</div>
                </div>
                <div class="flex-grow-1 tr total">
                  <span>共</span>
                  <span class="num">{{ tablist[tabIndex].activityGoods.length }}</span>
                  <span>件商品</span>
                </div>
                <div class="flex-box btn_select" :class="{ active: isShowSelect2 }" @click="toggleSelect2">
                  <div class="fwb">筛选</div>
                  <i class="icon_select"></i>
                </div>
              </div>
              <!-- 筛选区 -->
              <div class="select_box" v-if="isShowSelect2">
                <div class="flex-box select_row">
                  <div class="type">筛选项</div>
                  <div class="selected_item flex-box" v-if="query.sort == 'price' && query.order">
                    <div class="key" v-if="query.sort == 'price'">价格：</div>
                    <div class="value flex-box">
                      <div v-if="query.order == 'desc'">由高到低</div>
                      <div v-if="query.order == 'asc'">由低到高</div>
                      <i class="icon_del" @click="clearSort"></i>
                    </div>
                  </div>
                  <div class="selected_item flex-box" v-if="query.sort == 'stock' && query.order">
                    <div class="key" v-if="query.sort == 'stock'">价格：</div>
                    <div class="value flex-box">
                      <div v-if="query.order == 'desc'">由多到少</div>
                      <div v-if="query.order == 'asc'">由少到多</div>
                      <i class="icon_del" @click="clearSort"></i>
                    </div>
                  </div>
                  <div class="selected_item flex-box" v-if="query.min_price || query.max_price">
                    <div class="key">价格：</div>
                    <div class="value flex-box">
                      <div class="m-ellipsis" style="max-width: 200px">
                        {{ query.min_price ? query.min_price : 0 }} ~ {{ query.max_price }}
                      </div>
                      <i class="icon_del" @click="clearPrice"></i>
                    </div>
                  </div>

                  <div class="selected_item flex-box" v-if="query.min_stock || query.max_stock">
                    <div class="key">库存：</div>
                    <div class="value flex-box">
                      <div class="m-ellipsis" style="max-width: 200px">
                        {{ query.min_stock ? query.min_stock : 0 }} ~ {{ query.max_stock }}
                      </div>
                      <i class="icon_del" @click="clearStock"></i>
                    </div>
                  </div>
                </div>
                <div class="flex-box select_row">
                  <div class="type">库存数量</div>
                  <div class="type_value" @click="clearAllStock">全部</div>
                  <div
                    class="type_value"
                    :class="query.sort == 'stock' && query.order == 'desc' ? 'active' : ''"
                    @click="sortOrder('stock', 'desc')"
                  >
                    由多到少
                  </div>
                  <div
                    class="type_value"
                    :class="query.sort == 'stock' && query.order == 'asc' ? 'active' : ''"
                    @click="sortOrder('stock', 'asc')"
                  >
                    由少到多
                  </div>
                  <div class="flex-box custom_wrap">
                    <input
                      v-model="query.min_stock"
                      type="number"
                      class="custom_box m-input"
                      placeholder="自定最少数量"
                      @blur="refresh"
                    />
                    <div class="line1"></div>
                    <input
                      v-model="query.max_stock"
                      type="number"
                      class="custom_box m-input"
                      placeholder="自定最高数量"
                      @blur="refresh"
                    />
                  </div>
                </div>
                <div class="flex-box select_row">
                  <div class="type">价格区间</div>
                  <div class="type_value" @click="clearAllPrice">全部</div>
                  <div
                    class="type_value"
                    :class="query.sort == 'price' && query.order == 'desc' ? 'active' : ''"
                    @click="sortOrder('price', 'desc')"
                  >
                    由高到低
                  </div>
                  <div
                    class="type_value"
                    :class="query.sort == 'price' && query.order == 'asc' ? 'active' : ''"
                    @click="sortOrder('price', 'asc')"
                  >
                    由低到高
                  </div>
                  <div class="flex-box custom_wrap">
                    <input
                      v-model="query.min_price"
                      type="number"
                      class="custom_box m-input"
                      placeholder="自定最低价格"
                      @blur="refresh"
                    />
                    <div class="line1"></div>
                    <input
                      v-model="query.max_price"
                      type="number"
                      class="custom_box m-input"
                      placeholder="自定最高价格"
                      @blur="refresh"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 列表 -->
            <div class="product_list1 flex-box flex-wrap flex-col-start">
              <!-- 万件拼团 列表-->
              <template v-if="tablist[tabIndex].type == 'groupon'">
                <template v-for="(item, index) in tablist[tabIndex].activityGoods" :key="index">
                  <router-link
                    class="product_item"
                    :target="isLogin ? '_blank' : ''"
                    :to="
                      '/FindProductDetail?id=' +
                      item.id +
                      '&activity_id=' +
                      item.activity.id +
                      '&activity_type=' +
                      item.activity.type
                    "
                  >
                    <div class="img_wrap">
                      <img :src="item.image_text" class="img1" />
                      <div class="flex-box flex-between mt20">
                        <div class="fs12 zcol96">拼团进度</div>
                        <div class="progress_bar flex-box">
                          <div class="progress_inner" :style="{ width: item.rate + '%' }"></div>
                        </div>
                        <div class="fs12 progress_num">{{ item.rate }}%</div>
                      </div>
                    </div>
                    <div class="info_wrap fs16">
                      <div class="m-ellipsis name">{{ item.title }}</div>
                      <div class="mb5 zprice1 fwb" v-if="!userInfo">价格登录可见</div>
                      <div class="mb5 flex-box flex-col-baseline zprice1" v-else>
                        <p class="fs12 fwb">¥</p>
                        <p class="fwb" v-if="item.new_sku_prices[0].prices.length>1">
                          {{item.new_sku_prices[0].prices[0]+'~'+item.new_sku_prices[0].price}}
                        </p>
                        <p class="fwb" v-else-if="item.new_sku_prices[0].prices.length==1">
                          {{item.new_sku_prices[0].prices[0]}}
                        </p>
                        <p class="fs12">元/{{ item.unit }}</p>
                      </div>
                      <div class="spec_wrap fs12 zcol96 lh16">
                        <template v-for="(params, indexs) in item.params_text" :key="indexs">
                          <div class="mb5 m-ellipsis" v-if="indexs < 3">{{ params.title }}：{{ params.content }}</div>
                        </template>
                      </div>
                      <div class="btn_1">立即拼团</div>
                    </div>
                  </router-link>
                </template>
              </template>

              <!-- 新品体验 列表 -->
              <template v-if="tablist[tabIndex].type == 'new_sample'">
                <template v-for="(item, index) in tablist[tabIndex].activityGoods" :key="index">
                  <router-link
                    class="product_item"
                    :target="isLogin ? '_blank' : ''"
                    :to="
                      '/FindProductDetail?id=' +
                      item.id +
                      '&activity_id=' +
                      item.activity.id +
                      '&activity_type=' +
                      item.activity.type
                    "
                  >
                    <div class="baoming" v-if="item.is_join == 1"></div>
                    <div class="img_wrap">
                      <img :src="item.image_text" class="img1" />
                    </div>
                    <div class="info_wrap fs16">
                      <div class="m-ellipsis name">{{ item.title }}</div>
                      <div class="mb5 zprice1 fwb" v-if="!userInfo">价格登录可见</div>
                      <div class="flex-box flex-col-baseline mb5 zprice1" v-else>
                        <div class="fs12 fwb">¥</div>
                        <div class="fwb">
                          {{ item.new_sku_prices[0].price }}
                        </div>
                        <div class="fs12">元/{{ item.unit }}</div>
                      </div>
                      <div class="spec_wrap fs12">
                        <div class="zcol96 mb5 lh16 m-ellipsis">
                          活动时间：{{ item.activity.start_time_text }}—{{ item.activity.end_time_text }}
                        </div>
                        <template v-for="(params, indexs) in item.params_text" :key="indexs">
                          <div class="zcol96 mb5 lh16 m-ellipsis" v-if="indexs < 1">{{ params.title }}：{{ params.content }}</div>
                        </template>
                        <div class="zcol96 mb5 lh16 m-ellipsis">
                          剩余名额：{{ item.new_sku_prices[0].stock }}个
                        </div>
                      </div>
                      <div class="btn_1">立即报名</div>
                    </div>
                  </router-link>
                </template>
              </template>

              <!-- 限时购 列表 -->
              <template v-if="tablist[tabIndex].type == 'seckill'">
                <template v-for="(item, index) in tablist[tabIndex].activityGoods" :key="index">
                  <router-link
                    class="product_item"
                    :target="isLogin ? '_blank' : ''"
                    :to="
                      '/FindProductDetail?id=' +
                      item.id +
                      '&activity_id=' +
                      item.activity.id +
                      '&activity_type=' +
                      item.activity.type
                    "
                  >
                    <div class="img_wrap">
                      <img :src="item.image_text" class="img1" />
                      <div class="endline fs14">剩余库存：{{ item.new_sku_prices[0].stock }}</div>
                    </div>
                    <div class="info_wrap fs16">
                      <div class="m-ellipsis-l2 name">{{ item.title }}</div>
                      <div class="mb5 zprice1 fwb" v-if="!userInfo">价格登录可见</div>
                      <div class="flex-box flex-col-baseline mb5 zprice1">
                        <div class="fs12 fwb">¥</div>
                        <div class="fwb">{{ item.new_sku_prices[0].price }}</div>
                        <div class="fs12">元/{{ item.unit }}</div>
                      </div>
                      <div class="spec_wrap">
                        <template v-for="(params, indexs) in item.params_text" :key="indexs">
                          <div class="fs12 zcol96 mb5 lh16 m-ellipsis" v-if="indexs < 3">
                            {{ params.title }}：{{ params.content }}
                          </div>
                        </template>
                      </div>
                      <div class="btn_1" v-if="spikesIndex == 0">立即秒杀</div>
                      <div class="btn_1" v-else-if="spikesIndex == 1">立即预约</div>
                    </div>
                  </router-link>
                </template>
              </template>

              <!-- 临期产品 -->
              <template v-if="tablist[tabIndex].type == 'expiry_food'">
                <template v-for="(item, index) in tablist[tabIndex].activityGoods" :key="index">
                  <router-link
                    class="product_item"
                    :target="isLogin ? '_blank' : ''"
                    :to="
                      '/FindProductDetail?id=' +
                      item.id +
                      '&activity_id=' +
                      item.activity.id +
                      '&activity_type=' +
                      item.activity.type
                    "
                  >
                    <div class="img_wrap">
                      <img :src="item.image_text" class="img1" />
                      <div class="endline fs14" v-if="item.new_sku_prices.length > 0">
                        有 效 期：{{ item.new_sku_prices[0].expiretime }}
                      </div>
                    </div>
                    <div class="info_wrap fs16">
                      <div class="m-ellipsis name">{{ item.title }}</div>
                      <div class="mb5 zprice1 fwb" v-if="!userInfo">价格登录可见</div>
                      <div v-if="userInfo" class="flex-box flex-col-baseline mb5 zprice1">
                        <div class="fs12 fwb">¥</div>
                        <div class="fwb">
                          {{ item.new_sku_prices[0].price }}
                        </div>
                        <div class="fs12">元/{{ item.unit }}</div>
                      </div>
                      <div class="spec_wrap">
                        <template v-for="(params, indexs) in item.params_text" :key="indexs">
                          <div class="fs12 zcol96 mb5 m-ellipsis lh16" v-if="indexs < 3">
                            {{ params.title }}：{{ params.content }}
                          </div>
                        </template>
                      </div>
                      <div class="btn_1">立即购买</div>
                    </div>
                  </router-link>
                </template>
              </template>
            </div>

            <div v-if="tablist[tabIndex].activityGoods.length == 0" class="nodata fs18 tc">
              <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
              <div>暂无相关数据</div>
            </div>
          </div>
          <!-- 更多  -->
          <div
            v-if="tablist[tabIndex].activityGoods.length != 0 && currentData.current_page < currentData.last_page"
            class="flex-box flex-center flex-col-start more"
            @click="getMore()"
          >
            <div class="fs18">点击查看更多</div>
            <img src="@/assets/static/icon/z_icon_down3.png" class="icon_down" />
          </div>
        </div>
      </div>

      <div style="display: none" class="select_wrap w1440" v-if="tablist[tabIndex].type != 'seckill'">
        <!-- 筛选区 -->
        <div class="select_box" v-if="isShowSelect1">
          <div class="flex-box select_row fs16">
            <div class="type">筛选项</div>
            <div class="selected_item flex-box" v-if="query.sort == 'price' && query.order">
              <div class="key" v-if="query.sort == 'price'">价格：</div>
              <div class="value flex-box">
                <div v-if="query.order == 'desc'">由高到低</div>
                <div v-if="query.order == 'asc'">由低到高</div>
                <i class="icon_del" @click="clearSort"></i>
              </div>
            </div>
            <div class="selected_item flex-box" v-if="query.sort == 'stock' && query.order">
              <div class="key" v-if="query.sort == 'stock'">库存：</div>
              <div class="value flex-box">
                <div v-if="query.order == 'desc'">由多到少</div>
                <div v-if="query.order == 'asc'">由少到多</div>
                <i class="icon_del" @click="clearSort"></i>
              </div>
            </div>
            <div class="selected_item flex-box" v-if="query.min_price || query.max_price">
              <div class="key">价格：</div>
              <div class="value flex-box">
                <div>{{ query.min_price ? query.min_price : 0 }} ~ {{ query.max_price }}</div>
                <i class="icon_del" @click="clearPrice"></i>
              </div>
            </div>
            <div class="selected_item flex-box" v-if="query.min_stock || query.max_stock">
              <div class="key">库存：</div>
              <div class="value flex-box">
                <div>{{ query.min_stock ? query.min_stock : 0 }} ~ {{ query.max_stock }}</div>
                <i class="icon_del" @click="clearStock"></i>
              </div>
            </div>
          </div>

          <div class="flex-box select_row fs16">
            <div class="type">库存数量</div>
            <div class="type_value" @click="clearAllStock">全部</div>
            <div
              class="type_value"
              :class="query.sort == 'stock' && query.order == 'desc' ? 'active' : ''"
              @click="sortOrder('stock', 'desc')"
            >
              由多到少
            </div>
            <div
              class="type_value"
              :class="query.sort == 'stock' && query.order == 'asc' ? 'active' : ''"
              @click="sortOrder('stock', 'asc')"
            >
              由少到多
            </div>
            <div class="flex-box custom_wrap">
              <input
                v-model="query.min_stock"
                type="number"
                class="custom_box m-input fs16"
                placeholder="自定最少数量"
                @blur="refresh"
              />
              <div class="line1"></div>
              <input
                v-model="query.max_stock"
                type="number"
                class="custom_box m-input fs16"
                placeholder="自定最高数量"
                @blur="refresh"
              />
            </div>
          </div>
          <div class="flex-box select_row fs16">
            <div class="type">价格区间</div>
            <div class="type_value" @click="clearAllPrice">全部</div>
            <div
              class="type_value"
              :class="query.sort == 'price' && query.order == 'desc' ? 'active' : ''"
              @click="sortOrder('price', 'desc')"
            >
              由高到低
            </div>
            <div
              class="type_value"
              :class="query.sort == 'price' && query.order == 'asc' ? 'active' : ''"
              @click="sortOrder('price', 'asc')"
            >
              由低到高
            </div>
            <div class="flex-box custom_wrap">
              <input
                v-model="query.min_price"
                type="number"
                class="custom_box m-input"
                placeholder="自定最低价格"
                @blur="refresh"
              />
              <div class="line1"></div>
              <input
                v-model="query.max_price"
                type="number"
                class="custom_box m-input"
                placeholder="自定最高价格"
                @blur="refresh"
              />
            </div>
          </div>
        </div>
        <!--  -->
        <div class="rank_row flex-box w1440 fs16">
          <div class="flex-box rank" :class="query.sort == 'sales' ? 'active' : ''" @click="onSort('sales')">
            <div>产品销量</div>
            <img
              v-if="query.sort == 'sales' && query.order == 'asc'"
              src="@/assets/static/icon/z_icon_rank2.png"
              class="icon_rank"
            />
            <img
              v-else-if="query.sort == 'sales' && query.order == 'desc'"
              src="@/assets/static/icon/z_icon_rank3.png"
              class="icon_rank"
            />
            <img v-else src="@/assets/static/icon/z_icon_rank1.png" class="icon_rank" />
          </div>
          <div class="flex-box rank" :class="query.sort == 'price' ? 'active' : ''" @click="onSort('price')">
            <div>价格区间</div>
          </div>
          <div class="flex-box rank" :class="query.sort == 'stock' ? 'active' : ''" @click="onSort('stock')">
            <div>库存数量</div>
          </div>
          <div class="flex-grow-1 tr total">
            <span>共</span>
            <span class="num">{{ tablist[tabIndex].activityGoods.length }}</span>
            <span>件商品</span>
          </div>
          <div class="flex-box btn_select" :class="{ active: isShowSelect1 }" @click="toggleSelect1">
            <div class="fwb">筛选</div>
            <i class="icon_select"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <!-- <loginPop :visible="isShowLogin" @close="isShowLogin = false" @loginSuc="loginSuc"></loginPop> -->
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import { ref, onMounted } from "vue";
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "../../../node_modules/swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import moment from "moment";
import countDown2 from "../../components/countDown2.vue";
export default {
  name: "Activities",
  data() {
    return {
      banner: [], // 顶部轮播
      activityType: "",
      userInfo: null,
      tablist: [
        {
          type: "groupon",
          name: "",
          activityGoods: [],
        },
      ],
      tabIndex: 0,
      navIndex: 0,
      spikesIndex: 0,
      show: false,
      priceIndex: null,
      jobIndex: 0,
      query: {
        keyword: "",
        min_price: "",
        max_price: "",
        min_stock: "",
        max_stock: "",
        sort: "",
        order: "",
      },
      timeData: {},
      page: 1,

      // ====================

      tabIdx1: 1,
      activityList: [], // 全部数据
      activityList0: [], // 万件拼团
      activityList1: [], // 新品体验
      activityList2: [],
      activityList3: [], // 临期产品
      isShowSelect1: false, // 切换筛选1
      isShowSelect2: false, // 切换筛选2 今日秒杀 明日预告
      tadayTabIndex: 1, // 今日秒杀 明日预告 tab
      todayList: null,
      tomorrowList: null,
      todaysh: "00",
      todaysm: "00",
      todayeh: "00",
      todayem: "00",
      tomorrowsh: "00",
      tomorrowsm: "00",
      tomorroweh: "00",
      tomorrowem: "00",
      // ==========================
      // isShowLogin: false
      currentData: null,
      isLogin: false,
    };
  },
  created() {
    if (this.$cookies.get("token")) {
      this.isLogin = true;
      this.userInfo = this.$cookies.get("userinfo");
    }
    this.activityType = this.$route.query.type || "groupon";
    this.getBanner();
    this.fetchActivity();
    this.getSeckillTime();
  },
  methods: {
    // 获取轮播
    getBanner() {
      let that = this;
      that.$api.GetBanner({ group: "pc_activity" }).then((res) => {
        that.banner = res.data.pc_activity;
      });
    },
    jump(url){
				if(url){
					window.open(url, "_blank");
				}
				
			},
    // 获取活动
    fetchActivity() {
      this.$api.GetActivity().then((res) => {
        if (res.code == 1) {
          this.tablist = res.data;
          for (let i = 0; i < this.tablist.length; i++) {
            if (this.tablist[i].type == this.activityType) {
              this.tabIndex = i;
              break;
            }
          }
          // this.fetchActivityGoods();
          this.tablist[this.tabIndex].type == "seckill" ? this.checkSpikes(0) : this.fetchActivityGoods();
        }
      });
    },

    //活动切换
    onActivityClick(i) {
      this.tabIndex = i;
      for (let i = 0; i < this.tablist.length; i++) {
        this.tablist[i].activityGoods = [];
      }
      this.page = 1;
      // this.fetchActivityGoods();
      this.tablist[this.tabIndex].type == "seckill" ? this.checkSpikes(0) : this.fetchActivityGoods();
    },

    // 获取商品
    fetchActivityGoods() {
      let that = this;
      let tabIndex = that.tabIndex;
      let activityId = that.tablist[tabIndex].activity;
      activityId = activityId.length ? activityId.join(",") : "0";
      let query = that.query;
      query.list_rows = 10;
      query.activity_id = activityId;
      query.page = that.page;

      this.$api.GetSpikesList(query).then((res) => {
        if (res.code == 1) {
          this.currentData = res.data;
          this.tablist[tabIndex].activityGoods = this.tablist[tabIndex].activityGoods.concat(res.data.data);
        }
        // console.log(res.data)
        // console.log(this.tablist[tabIndex].activityGoods)
      });

      if (
        that.tablist[tabIndex].type == "seckill" &&
        (that.tablist[tabIndex].today_activity || that.tablist[tabIndex].tomorrow_activity)
      ) {
        setTimeout(function () {
          that.$refs.countDown.start();
        }, 500);
      }
    },

    // 刷新
    refresh() {
      for (let i = 0; i < this.tablist.length; i++) {
        this.tablist[i].activityGoods = [];
      }
      this.page = 1;
      this.fetchActivityGoods();
    },

    // 查看更多
    getMore() {
      this.page = this.page + 1;
      this.fetchActivityGoods();
    },

    //排序
    onSort(sort) {
      this.query.sort = sort;
      this.query.order = this.query.order == "asc" ? "desc" : "asc";
      this.refresh();
    },
    sortOrder(sort, order) {
      this.query.sort = sort;
      this.query.order = order;
      this.refresh();
    },
    clearSort() {
      this.query.order = "";
      this.refresh();
    },
    clearPrice() {
      this.query.min_price = "";
      this.query.max_price = "";
      this.refresh();
    },
    clearStock() {
      this.query.min_stock = "";
      this.query.max_stock = "";
      this.refresh();
    },
    clearAllStock() {
      this.query.sort = "";
      this.query.order = "";
      this.query.min_stock = "";
      this.query.max_stock = "";
      this.refresh();
    },
    clearAllPrice() {
      this.query.sort = "";
      this.query.order = "";
      this.query.min_price = "";
      this.query.max_price = "";
      this.refresh();
    },
    // 切换筛选1
    toggleSelect1() {
      this.isShowSelect1 = !this.isShowSelect1;
    },
    // 切换筛选2 今日秒杀 明日预告
    toggleSelect2() {
      this.isShowSelect2 = !this.isShowSelect2;
    },

    // 今日秒杀 明日预告 tab
    checkSpikes(index) {
      this.spikesIndex = index;
      this.tablist[this.tabIndex].activityGoods = [];
      this.page = 1;
      if (this.spikesIndex == 0) {
        this.tablist[this.tabIndex].activity = this.tablist[this.tabIndex].today_activity
          ? [this.tablist[this.tabIndex].today_activity.id]
          : [];
      } else {
        this.tablist[this.tabIndex].activity = this.tablist[this.tabIndex].tomorrow_activity
          ? [this.tablist[this.tabIndex].tomorrow_activity.id]
          : [];
      }
      this.fetchActivityGoods();
    },
    // 倒计时
    onChange(e) {
      this.timeData = e;
    },

    // 设置时间
    getSeckillTime() {
      this.$api.GetActivity().then((res) => {
        if (res.code == 1) {
          let list = res.data;
          list.map((item) => {
            if (item.type == "seckill") {
              this.activityList2 = item;
              if (this.activityList2.today_activity) {
                this.todayList = this.activityList2.today_activity;
                this.todaysh = moment(this.todayList.start_time * 1000).format("HH");
                this.todaysm = moment(this.todayList.start_time * 1000).format("mm");
                this.todayeh = moment(this.todayList.end_time * 1000).format("HH");
                this.todayem = moment(this.todayList.end_time * 1000).format("mm");
                let activityId = this.activityList2.activity;
                activityId = activityId.length ? activityId.join(",") : "0";
                // this.checkSpikesToday(activityId);
              }
              if (this.activityList2.tomorrow_activity) {
                this.tomorrowList = this.activityList2.tomorrow_activity;
                this.tomorrowsh = moment(this.todayList.start_time * 1000).format("HH");
                this.tomorrowsm = moment(this.todayList.start_time * 1000).format("mm");
                this.tomorroweh = moment(this.todayList.end_time * 1000).format("HH");
                this.tomorrowem = moment(this.todayList.end_time * 1000).format("mm");
                let activityId = this.activityList2.activity;
                activityId = activityId.length ? activityId.join(",") : "0";
                // this.checkSpikesTomorrow(activityId);
              }
            }
          });
        }
      });
    },
    //开始
    start() {
      this.$refs.countDown.start();
    },
    // loginSuc() {
    //   this.isShowLogin = false;
    //   this.$bus.emit("refreshLogin");
    //   window.location.reload();
    // },
  },
  components: {
    countDown2,
    Swiper,
    SwiperSlide,
  },
  setup() {
    let swi = ref("");
    const onSwiper = (e) => {
      swi.value = e;
    };

    // let endTime = ref(18600);
    const coutimg = ref(require("../../assets/static/images/jj_countdown_red.png"));
    const coutimg_gray = ref(require("../../assets/static/images/jj_countdown_gray.png"));
    onMounted(() => {
      useHead({
        title: "活动中心-小狮优选",
        meta: [
          { name: "description", content: "This is my page description" },
          { property: "og:title", content: "My Page Title" },
          { property: "og:description", content: "This is my page description" },
          { property: "og:url", content: "https://example.com/my-page" },
          { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
      });
    });
    return {
      onSwiper,
      modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode],
      // endTime,
      coutimg,
      coutimg_gray,
    };
  },
};
</script>
<style lang="less" scoped>
.activities_wrap {
  // padding: 0 0 60px;
  padding: 0 0 0.2rem;

  .img_banner_wrap {
    margin: 0 auto 30px;
    // width: 1440px;
    height: 700px;
  }

  .img_banner {
    display: block;
    width: 100%;
  }

  .menu_row {
    margin: 10px auto 0;

    .menu_tab {
      flex: 1;
      // width: 355px;
      // height: 205px;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
      }

      i {
        display: block;
        width: 360px;
        height: 180px;
        background-repeat: no-repeat;
        background-size: 360px 180px;
        border-radius: 10px;
      }

      .icon_menu1 {
        background-image: url(@/assets/static/icon/z_icon_menu_pic1.png);
      }

      .icon_menu2 {
        background-image: url(@/assets/static/icon/z_icon_menu_pic2.png);
      }

      .icon_menu3 {
        background-image: url(@/assets/static/icon/z_icon_menu_pic3.png);
      }

      .icon_menu4 {
        background-image: url(@/assets/static/icon/z_icon_menu_pic4.png);
      }
    }
    .menu_tab + .menu_tab {
      margin-left: 5px;
    }

    // .menu_tab.active {
    //   background: #3d7efe;

    //   div {
    //     color: #ffffff;
    //   }

    //   .icon_menu1 {
    //     background-image: url(@/assets/static/icon/z_icon_menu1on.png);
    //   }

    //   .icon_menu2 {
    //     background-image: url(@/assets/static/icon/z_icon_menu2on.png);
    //   }

    //   .icon_menu3 {
    //     background-image: url(@/assets/static/icon/z_icon_menu3on.png);
    //   }

    //   .icon_menu4 {
    //     background-image: url(@/assets/static/icon/z_icon_menu4on.png);
    //   }
    // }
  }
}

.select_wrap {
  margin: 10px auto 0;
  background-color: #fff;

  .select_box {
    padding: 20px 30px;
    background: #ffffff;

    .select_row + .select_row {
      margin-top: 10px;
    }

    .type {
      width: 160px;
      color: #909090;
      line-height: 20px;
    }

    .selected_item {
      margin: 0 45px 0 0;
      padding: 0 20px;
      height: 46px;
      border-radius: 8px;
      background: #3d7efe;

      .value {
        font-weight: 700;
        line-height: 32px;

        .icon_del {
          margin-left: 13px;
          display: block;
          width: 22px;
          height: 22px;
          background-image: url(@/assets/static/icon/z_icon_delete2.png);
          background-size: 22px;
          background-repeat: no-repeat;
          cursor: pointer;
        }

        div {
          color: #fff;
        }
      }

      .value + .value {
        margin-left: 10px;
      }

      .key {
        color: #ffffff;
        line-height: 32px;
      }
    }

    .type_value {
      color: #040404;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
    }

    .type_value + .type_value {
      margin-left: 68px;
    }

    .type_value.active {
      color: #3d7efe;
      font-weight: 700;
    }

    .custom_wrap {
      margin-left: 100px;

      .line1 {
        margin: 0 55px;
        width: 66px;
        height: 1px;
        background: #dedede;
      }

      .custom_box {
        padding: 0 10px;
        width: 250px;
        height: 46px;
        background: rgba(150, 150, 150, 0.06);
        border-radius: 8px;
        color: #333;
        line-height: 46px;
        text-align: center;
        font-style: normal;
      }
    }
  }

  .rank_row {
    padding: 0 40px;
    line-height: 50px;
    background: #deecff;

    .rank {
      margin-right: 110px;
      color: #040404;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      cursor: pointer;

      div {
        color: #040404;
      }

      .icon_rank {
        margin-left: 2px;
        display: block;
        width: 20px;
        height: 20px;
      }
    }

    .rank.active {
      div {
        color: #3d7efe;
        font-weight: 700;
      }
    }

    .total {
      margin-right: 92px;
      line-height: 50px;

      span {
        color: #040404;
      }

      .num {
        margin: 0 2px;
        color: #3d7efe;
        font-weight: 700;
      }
    }

    .btn_select {
      line-height: 36px;
      font-style: normal;
      cursor: pointer;

      div {
        color: #040404;
      }

      .icon_select {
        margin-left: 8px;
        display: block;
        width: 18px;
        height: 18px;
        background-image: url("@/assets/static/icon/z_icon_select2.png");
        background-repeat: no-repeat;
        background-size: 18px;
      }
    }
    .btn_select.active {
      div {
        color: #3d7efe;
      }
      .icon_select {
        background-image: url("@/assets/static/icon/z_icon_select3.png");
      }
    }
  }
}

.today_tab {
  margin: 26px 0 0;
  height: 125px;
  background-repeat: no-repeat;
  background-size: 100% 125px;

  .tab_item {
    height: 125px;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .tab_item1 {
    background-size: 222.5px 58px;
    background-image: url(@/assets/static/icon/z_icon_today1.png);
  }

  .tab_item1.active {
    background-image: url(@/assets/static/icon/z_icon_today2.png);
  }

  .tab_item2 {
    background-size: 230px 58px;
    background-image: url(@/assets/static/icon/z_icon_tomorrow1.png);
  }

  .tab_item2.active {
    background-image: url(@/assets/static/icon/z_icon_tomorrow2.png);
  }
}

.today_tab.active1 {
  background-image: url(@/assets/static/icon/z_icon_tab_bg1.png);
}

.today_tab.active2 {
  background-image: url(@/assets/static/icon/z_icon_tab_bg2.png);
}

// 顶部标题
.title_box {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 22px 0 0;
  width: 1080px;
  height: 92px;
  background-size: 1080px 92px;
  background-repeat: no-repeat;

  .icon_title1 {
    margin: 0 auto;
    display: block;
    width: 301px;
    height: 64px;
  }
}
.title_box.groupon {
  background-image: url(@/assets/static/icon/z_icon_title_bg1.png);
}
.title_box.new_sample {
  background-image: url(@/assets/static/icon/z_icon_title_bg2.png);
}
.title_box.expiry_food {
  background-image: url(@/assets/static/icon/z_icon_title_bg3.png);
}

.product_box2 {
  position: relative;
  padding: 36px 36px 25px;
  margin: 56px auto 0;
  border-radius: 32px;

  .product_list1 {
    padding: 10px 0 0;
    .product_item {
      position: relative;
      margin: 14px 14px 0 0;
      // width: 310px;
      width: calc((100% - 42px) / 4);
      background: #ffffff;
      border-radius: 18px;
    }

    .product_item:nth-of-type(4n) {
      margin: 14px 0 0;
    }

    .img_wrap {
      position: relative;
      // padding: 25px 0 10px;
      padding: 20px;
      border-bottom: 1px solid #ececec;

      .img1 {
        margin: 0 auto;
        display: block;
        // width: 180px;
        // height: 180px;
        width: 270px;
        height: 270px;
        border-radius: 18px;
      }
    }
    .endline {
      margin: 20px auto 0;
      // width: 212px;
      height: 22px;
      background: #d7e5ff;
      border-radius: 4px;
      color: #70a0fe;
      line-height: 22px;
      text-align: center;
      font-style: normal;
    }

    .info_wrap {
      padding: 20px;
      // height: 200px;
      .name {
        margin: 0 0 5px;
        font-weight: 700;
        color: #272727;
        line-height: 22px;
        text-align: left;
      }

      .btn_1 {
        margin: 14px auto 0;
        height: 32px;
        background: #3d7efe;
        border-radius: 14px;
        font-size: 16px;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        font-style: normal;
      }

      .fs13 {
        line-height: 18px;
      }

      .zprice1 {
        // letter-spacing: 1px;

        div {
          line-height: 22px;
        }
      }
    }

    .baoming {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 18px;
      background-image: url(@/assets/static/icon/z_icon_baoming.png);
      background-size: 178px 150px;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 2;
    }
  }

  .product_box2_inner {
    padding: 66px 42px 42px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.4);

    .countdown_box {
      margin: 0 0 20px;
      // width: 1284px;
      border-radius: 8px;
      background: #ffffff;
      padding: 24px 44px 15px;
    }

    .btn_count {
      padding: 0 36px;
      height: 55px;
      text-align: center;
      font-size: 24px;
      line-height: 53px;
      border-radius: 27px;
      border: 1px solid #fe7e7e;

      &_uc {
        padding: 0 31px;
        height: 55px;
        text-align: center;
        font-size: 24px;
        line-height: 53px;
        border-radius: 27px;
        border: 1px solid #d8d8d8;

        span {
          color: #969696;
          background: transparent;
        }
      }

      span {
        background: linear-gradient(180deg, #fe7c7c 0%, #ffafaf 100%);
        /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
        background-clip: text;
        -webkit-background-clip: text;
        /*将设置的背景颜色限制在文字中*/
        -webkit-text-fill-color: transparent;
        /*给文字设置成透明*/
      }
    }

    .count_item {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 101px;
      height: 73px;
      color: #ffffff;
      font-size: 60px;
      font-stretch: condensed;
      font-weight: 700;
      text-align: center;
      line-height: 73px;
      letter-spacing: 18px;
      padding: 0 5px;
    }

    .count_span {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 26.35px;
      height: 101.35px;
      background-image: url("../../assets/static/images/jj_countdown_red_f.png");

      &.gray {
        background-image: url("../../assets/static/images/jj_countdown_gray_f.png");
      }
    }

    .count_span_split {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 30px;
      height: 88px;
      background-image: url("../../assets/static/images/jj_countdown_red_s.png");
      margin-left: 20px;
      margin-right: 20px;

      &.gray {
        background-image: url("../../assets/static/images/jj_countdown_gray_s.png");
      }
    }

    .ml8 {
      margin-left: 8px;
    }
  }

  .progress_num {
    color: #3d7efe;
    line-height: 14px;
  }

  .progress_bar {
    padding: 0 2px;
    margin: 0 15px;
    // width: 160px;
    flex: 1;
    height: 16px;
    border-radius: 20px;
    border: 1px solid #e3ecf7;

    .progress_inner {
      position: relative;
      height: 10px;
      background: #feb833;
      border-radius: 16px;
    }

    .progress_inner::after {
      content: "";
      position: absolute;
      right: -12px;
      top: 50%;
      transform: translateY(-50%);
      width: 25px;
      height: 25px;
      background-image: url(@/assets/static/icon/z_icon_progress.png);
      background-size: 25px;
      background-repeat: no-repeat;
    }
  }

  // 更多
  .more {
    margin: 25px 0 0;
    line-height: 28px;
    cursor: pointer;

    div {
      color: #6b6b6b;
    }

    .icon_down {
      margin-left: 10px;
      display: block;
      width: 18px;
      height: 18px;
    }
  }
}

.product_box2.groupon_box {
  background: #deecff;

  .product_item:hover {
    transform: translateY(-10px);
    box-shadow: 0px 2px 10px rgba(63, 117, 255, 0.4);
  }
}
.product_box2.new_sample_box {
  background: #fedd9d;
  .product_item:hover {
    transform: translateY(-10px);
    box-shadow: 0px 2px 10px rgba(220, 61, 11, 0.4);
  }
  .img_wrap {
    position: relative;
    // padding: 25px 0;
  }
}
.product_box2.seckill_box {
  margin: -24px auto 0;
  background: #ffdbdb;

  .product_box2_inner {
    padding: 36px 42px 24px;
  }
}
.product_box2.expiry_food_box {
  background: #dad7ff;
  .product_item:hover {
    transform: translateY(-10px);
    box-shadow: 0px 2px 10px rgba(157, 150, 255, 0.4);
  }
}
// 今日秒杀 明日预告 筛选
.select_wrap1 {
  .select_box {
    // padding: 48px 30px 75px 40px;
    padding: 20px 30px;
    background: #ffffff;

    .select_row + .select_row {
      margin-top: 10px;
    }

    .type {
      width: 160px;
      color: #909090;
      line-height: 20px;
    }

    .selected_item {
      // margin: 0 97px 0 0;
      // padding: 0 20px;
      // height: 58px;
      margin: 0 45px 0 0;
      padding: 0 20px;
      height: 46px;
      border-radius: 8px;
      background: #3d7efe;

      .value {
        font-weight: 700;
        line-height: 32px;

        .icon_del {
          margin-left: 13px;
          display: block;
          width: 22px;
          height: 22px;
          background-image: url(@/assets/static/icon/z_icon_delete2.png);
          background-size: 22px;
          background-repeat: no-repeat;
          cursor: pointer;
        }

        div {
          color: #fff;
        }
      }

      .value + .value {
        margin-left: 10px;
      }

      .key {
        color: #ffffff;
        line-height: 32px;
      }
    }

    .type_value {
      color: #040404;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
    }

    .type_value + .type_value {
      margin-left: 68px;
    }

    .type_value.active {
      color: #3d7efe;
      font-weight: 700;
    }

    .custom_wrap {
      margin-left: 100px;

      .line1 {
        margin: 0 28px;
        width: 66px;
        height: 2px;
        background: #dedede;
      }

      .custom_box {
        padding: 0 10px;
        width: 200px;
        height: 46px;
        background: rgba(150, 150, 150, 0.06);
        border-radius: 8px;
        color: #7a8499;
        line-height: 46px;
        text-align: center;
      }
    }
  }

  .rank_row {
    padding: 0 50px 0 44px;
    height: 50px;
    // background: rgba(222,236,255, 0.6);
    background: #f7faff;
    border-radius: 8px;

    .rank {
      margin-right: 110px;
      color: #040404;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      cursor: pointer;

      div {
        color: #040404;
      }

      .icon_rank {
        margin-left: 2px;
        display: block;
        width: 20px;
        height: 20px;
      }
    }

    .rank.active {
      div {
        color: #3d7efe;
        font-weight: 700;
      }
    }

    .total {
      margin-right: 120px;
      line-height: 36px;

      span {
        color: #040404;
      }

      .num {
        margin: 0 2px;
        color: #3d7efe;
        font-weight: 700;
      }
    }

    .btn_select {
      line-height: 36px;
      font-style: normal;
      cursor: pointer;
      div {
        color: #040404;
      }
      .icon_select {
        margin-left: 8px;
        display: block;
        width: 18px;
        height: 18px;
        background-image: url("@/assets/static/icon/z_icon_select2.png");
        background-repeat: no-repeat;
        background-size: 18px;
      }
    }
    .btn_select.active {
      div {
        color: #3d7efe;
      }
      .icon_select {
        background-image: url("@/assets/static/icon/z_icon_select3.png");
      }
    }
  }
}
.home_swiper {
  margin: 0 auto;
  width: 100%;
  height: 400px;
  position: relative;
  z-index: 1;

  .swiper_item {
   height: 400px;
  }

  .top_banner {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

.img_tip3 {
  color: #e61313;
  .time {
    color: #ff1e1e;
  }
  .text1 {
    color: #ff1e1e;
  }
  .ztime1 {
    color: #494949;
  }
}
.spec_wrap {
  height: 58px;
}
@media screen and (max-width: 1440px) {
  .product_box2 {
    .product_list1 {
      .img_wrap {
        .img1 {
          width: 230px;
          height: 230px;
        }
      }
    }
  }

  .type_value + .type_value {
    margin-left: 35px !important;
  }
  .custom_wrap {
    margin-left: 55px !important;
  }

  .home_swiper {
    height: 355px;

    .swiper_item {
      height: 355px;
    }
  }
}
</style>
